import { render, staticRenderFns } from "./OsReportContentCategoryForm.vue?vue&type=template&id=0137389a&scoped=true"
import script from "./OsReportContentCategoryForm.vue?vue&type=script&lang=ts"
export * from "./OsReportContentCategoryForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137389a",
  null
  
)

export default component.exports